class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()

    this.additionalHeaderLinks = this.querySelectorAll('a[href^="#"]')
    this.menus = this.querySelectorAll(".menu-drawer__inner-submenu")

    this.menus?.forEach(menu => {
      if (localStorage.getItem('active_menu')) {
        if (localStorage.getItem('active_menu') === menu.id) {
          menu.setAttribute("show", "")
        } else {
          menu.removeAttribute("show")
        }
      }
    })

    this.additionalHeaderLinks?.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()

        this.menus.forEach(menu => {
          if (menu.id === e.target.getAttribute('href').replace("#", "")) {
            menu.setAttribute("show", "")
            localStorage.setItem("active_menu", menu.id)
          } else {
            menu.removeAttribute("show")
            menu.setAttribute("forceopen", "")
          }
        })
      })
    })
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header")
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    )
    this.header.classList.add("menu-open")

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })

    summaryElement.setAttribute("aria-expanded", true)
    window.addEventListener("resize", this.onResize)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove("menu-open")
    window.removeEventListener("resize", this.onResize)
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      )
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    )
  }
}

customElements.define("header-drawer", HeaderDrawer)